import { render, staticRenderFns } from "./createEditMerchant.vue?vue&type=template&id=0b63eede&scoped=true&"
import script from "./createEditMerchant.vue?vue&type=script&lang=js&"
export * from "./createEditMerchant.vue?vue&type=script&lang=js&"
import style0 from "./createEditMerchant.vue?vue&type=style&index=0&id=0b63eede&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b63eede",
  null
  
)

export default component.exports